import styled from 'styled-components'
import {
	ArrowDownward as ArrowDownwardIcon,
	FilterList as FilterListIcon,
} from "@material-ui/icons";
import { Button, FormControlLabel } from "@material-ui/core";

import { MaterialSelector } from "components/Selector";
import { CrossButtonDark } from "components/Buttons/CrossButton";

export const Container = styled.div`
	padding: 1rem 0.5rem;
	background-color: #fff;
	height: 100%;
	width: 100%;
	box-sizing: border-box;
`

export const TitleContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding: 0 0.5rem;
`;

export const Title = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
`;

export const StyledArrowDownwardIcon = styled(ArrowDownwardIcon)`
	height: 20px !important;
	color: #0B4598FF;
	margin-right: 0.5rem;
`

export const StyledFilterListIcon = styled(FilterListIcon)`
	height: 20px !important;
	color: #0B4598FF;
	margin-right: 0.5rem;
`

export const TitleContentButton = styled.div`
	display: flex;
	align-items: center;
	font-size: 0.875rem;
	font-weight: 600;
	color: #0B4598FF;
	cursor: pointer;
`;

export const PopupContainerBase = styled.div`
  border-radius: 8px;
  background: white;
`

export const PopupContainer = styled(PopupContainerBase)`
  padding: 1.5rem 1rem;
  border-radius: 8px;
  background: white;
`

export const PopupTitle = styled.div`
  font-size: 1.2rem;
  line-height: 1.4;
  font-weight: 600;
`

export const PopupTitlesContainer = styled.div`
	padding: 0 1rem;
	margin-bottom: 1.75rem;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	position: relative;
	text-align: center;
`

export const SortingOptionButton = styled.div`
	color: rgba(0, 0, 0, 0.87);
	font-size: 1rem;
	width: 100%;
	padding: 0.75rem 1rem;
	cursor: pointer;
`;

export const StyledCrossButtonDark = styled(CrossButtonDark)`
  top: 0;
  bottom: 0;
  right: 0;
  position: relative;
`

export const PopupSectionContainer = styled.div`
	margin: 1.5rem 0;
	padding: 0 1rem;
	font-size: 16px;
`

export const SubmitButtonContainer = styled.div`
	margin: 3.5rem 0 1.5rem;
`

export const MultipleCheckboxesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 1rem;
  margin-top: 0.5rem;
`

export const StyledFormControlLabel = styled(FormControlLabel)`
  width: 40%;
`

export const CheckboxLabel = styled.div`
  font-size: 14px;
`

export const StyledMaterialSelector = styled(MaterialSelector)`
  padding-right: 2rem !important;
`

export const ResetFiltersButton = styled(Button)`
	text-transform: unset;
	font-weight: 600;
	font-size: 0.875rem;
	border-radius: 8px;
`
